export const MOVIE_EXPERIENCE_CONTENT = {
    PREMIUM: {
        img: "diamond_pink.svg",
        img1: "diamond_pink.svg",
        title: "Premium Experience",
        filmPageTitle: "Premium Experience Ticket",
        description: [
            'One Film Ticket',
            'First of its kind Immersive Experience',
            'Exclusive T-shirt for Premium Experience ticket holders',
            'The Phoenician Scheme Combo (Large Popcorn, Large Soda, King Size HERSHEY’S chocolate bar)'
        ],
        class:'premium'
    },
    STANDARD: {
        img: "ticket_blue.svg",
        img1: "ticket_grey.svg",
        title: "Standard Experience",
        filmPageTitle: "Standard Experience Ticket",
        description: [
            'One Film Ticket',
            'First of its kind Immersive Experience'
        ],
        class:'standard'
    }
}